module.exports = __webpack_public_path__ + "img/h-wrap-2-bg-en.8cd748ac.png";